import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './index.css';

export const ShareModalHeader: React.FunctionComponent = () => {
  return (
    <div className={styles['header']}>
      <UIHeading2>Настройки подборки</UIHeading2>
    </div>
  );
};
